import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spin } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import {
    onEnterUsuari,
    usuariIntroduccioSeleccionarUsuari
} from '../../actions';

import {
    selectorTotsUsuarisAmbMunicipiIRol,
    selectorUsuariOnEnterEnCurs,
    selectorHiHaEstructuraFormulariUsuari,
    selectorFormulariObtenirDadesEnCurs
} from '../../selectors/selector_usuari';

import { rutaIntroduccioUsuaris, rutaDetallUsuaris } from '../../routes/routeConstants';

import UsuariTaula from './usuariTaula';
import Error from '../commons/error';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import SpinnerBuitSempreActiu from '../commons/spinnerBuitSempreActiu';

class Usuari extends Component {

    constructor(props) {
        super(props);
        this.renderitzarTaula = this.renderitzarTaula.bind(this);
    }

    componentDidMount() {
        this.props.onEnterUsuari();
    }

    renderitzarTaula() {
        const { usuaris, usuariIntroduccioSeleccionarUsuari, router } = this.props;
        return (
            <UsuariTaula
                usuaris={usuaris}
                onClickUsuari={idUsuari => usuariIntroduccioSeleccionarUsuari(idUsuari, () => router.push(rutaDetallUsuaris))}
            />
        );
    }

    render() {
        const {
            onEnterUsuariEnCurs,
            obtenirDadesUsuariEnCurs,
            hiHaEstructuraFormulari
        } = this.props;


        if (!onEnterUsuariEnCurs && !hiHaEstructuraFormulari) {
            return <Error />;
        }

        const textSpinning = 'Carregant detall d\'usuari';

        return (
            <div className='usuari'>
                <Spin className='usuari-spinner'
                    spinning={obtenirDadesUsuariEnCurs}
                    tip={textSpinning}
                    >
                    <div className='usuari-boto-inserir'>
                        <Link to={rutaIntroduccioUsuaris}>
                            <Button type='primary' icon='plus-circle-o'>
                                Usuari
                            </Button>
                        </Link>
                    </div>
                    { onEnterUsuariEnCurs ? <SpinnerBuitSempreActiu /> : this.renderitzarTaula() }
                </Spin>
            </div>
        );
    }
}

Usuari.propTypes = {
    onEnterUsuari: PropTypes.func,
    onEnterUsuariEnCurs: PropTypes.bool,
    hiHaEstructuraFormulari: PropTypes.bool,
    obtenirDadesUsuariEnCurs: PropTypes.bool,
    usuaris: PropTypes.array,
    usuariIntroduccioSeleccionarUsuari: PropTypes.func,
    router: PropTypes.object
};

const mapsStateToProps = (state) => {
    return {
        usuaris: selectorTotsUsuarisAmbMunicipiIRol(state),
        onEnterUsuariEnCurs: selectorUsuariOnEnterEnCurs(state),
        hiHaEstructuraFormulari: selectorHiHaEstructuraFormulariUsuari(state),
        obtenirDadesUsuariEnCurs: selectorFormulariObtenirDadesEnCurs(state)
    };
};

const mapDispatchToProps = {
    onEnterUsuari,
    usuariIntroduccioSeleccionarUsuari
};

export default errorBoundaryWrapper(connect(mapsStateToProps, mapDispatchToProps)(Usuari));



// WEBPACK FOOTER //
// ./src/components/usuari/usuari.js